import { SmlsButton } from '@smiles/smiles-ui-kit-react';
import { useMemberData } from 'pages/FirstAccessFlow/context/MemberDataContext';
import React, { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { useTranslation } from 'react-i18next';

export function ContinueButton() {
  const { formType, formData, response, formEdited, submitMember, submittingMember } = useMemberData();
  const { t } = useTranslation('user_data_confirmation');
  const { t: t2 } = useTranslation('email');

  const [isDisabled, setButtonDisabled] = useState<boolean>(true);

  const validateSimpleForm = () => {
    const {
      email,
      confirmEmail,
      terms,
      cellPhone: {
        formatted: { display: phoneNumber },
      },
      streetName,
    } = formData;

    const dataToValidate = [email, confirmEmail, terms, phoneNumber, streetName];

    const isValid = dataToValidate.every((entry) => !!entry);

    setButtonDisabled(!isValid);
  };

  const validateCompleteForm = () => {
    const {
      email,
      confirmEmail,
      terms,
      cellPhone: {
        formatted: { display: phoneNumber },
      },
      streetName,
      city,
      country,
      state,
      streetNumber,
      zipCode,
    } = formData;

    const dataToValidate = [
      email,
      confirmEmail,
      terms,
      phoneNumber,
      streetName,
      city,
      country,
      state,
      streetNumber,
      zipCode,
    ];

    const isValid = dataToValidate.every((entry) => !!entry);

    setButtonDisabled(!isValid);
  };

  useEffect(() => {
    if (formType === 'SIMPLE') {
      validateSimpleForm();
      return;
    }

    validateCompleteForm();
  }, [formData, response]);

  const handleOnClick = () => {
    submitMember();
    const dataLayerArgs = {
      dataLayer: {
        event: 'select_content',
        dl_infos: {
          select_content: 'concordo-com-regulamento',
          selling_environment: 'cadastro-e-login',
          shelf: 'primeiro-acesso',
          page_location: window.location.href
        }
      },
    };
    TagManager.dataLayer(dataLayerArgs);
  };

  return (
    <div data-testid="first-access-continue-button">
      <SmlsButton
        id="first-access-continue-button"
        className="continue-button"
        color="primary"
        text={formEdited ? t('update_and_continue') : t2('continue')}
        disabled={isDisabled}
        onClick={handleOnClick}
        isLoading={submittingMember}
      />
    </div>
  );
}
